import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { WashingMachine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { TopInfoBar } from "@/components/nav/TopInfoBar";
import { AccountMenu } from "@/components/nav/AccountMenu";
import { MobileMenu } from "@/components/nav/MobileMenu";
import { NAV_LINKS } from "@/components/nav/links";

export const Navbar = () => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (anchor) => {
    if (pathname === "/") {
      document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = `/#${anchor}`;
    }
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-shadow duration-300 ${scrolled ? "shadow-lg shadow-slate-900/5" : ""}`}
    >
      <TopInfoBar collapsed={scrolled} />
      <div className="glass-nav">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <Link to="/" data-testid="nav-logo" className="group flex items-center gap-2.5 shrink-0">
            <span className="bg-gradient-to-br from-cyan-400 to-cyan-600 text-white p-2 rounded-xl shadow-md shadow-cyan-500/25 transition-transform duration-200 group-hover:scale-105 group-hover:-rotate-3">
              <WashingMachine className="h-5 w-5" />
            </span>
            <span className="font-heading font-extrabold text-lg leading-none tracking-tight text-slate-900 notranslate">
              Lavandería
              <span className="block text-sm font-bold bg-gradient-to-r from-cyan-600 to-cyan-400 bg-clip-text text-transparent">
                Ozono
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-0.5" aria-label="Principal">
            {NAV_LINKS.map((l) => (
              <button
                key={l.anchor}
                type="button"
                data-testid={`nav-${l.anchor}`}
                onClick={() => goTo(l.anchor)}
                className={`nav-link ${l.xl ? "hidden xl:inline-flex" : ""}`}
              >
                {l.label}
              </button>
            ))}
            <Link
              to="/seguimiento"
              data-testid="nav-seguimiento"
              className={`nav-link ${pathname === "/seguimiento" ? "nav-link-active" : ""}`}
            >
              Seguimiento
            </Link>
          </nav>

          <div className="flex items-center gap-1 sm:gap-2 shrink-0">
            <LanguageSwitcher />
            <AccountMenu />
            <Button asChild data-testid="nav-reservar-btn"
              className="hidden sm:inline-flex bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 rounded-full px-5 xl:px-6 shadow-md shadow-cyan-500/30 transition-shadow duration-200 hover:shadow-lg hover:shadow-cyan-500/40">
              <Link to="/reservar"><span>Reservar<span className="hidden xl:inline"> Recogida</span></span></Link>
            </Button>
            <MobileMenu goTo={goTo} />
          </div>
        </div>
      </div>
    </header>
  );
};
